exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sentence-swapper[data-v-54619d8c] {\n  perspective: 1000px;\n}\n.slider-frame[data-v-54619d8c] {\n  height: 50px;\n  overflow: hidden;\n  text-align: center;\n}\n.slides[data-v-54619d8c] {\n  transition: transform 0.6s cubic-bezier(0.4, 0.0, 0.2, 1);\n  transform: translateY(0px);\n}\n.slide[data-v-54619d8c] {\n  font-size: 24px;\n  line-height: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
